export const BACK_TO_SCHOOL_CURRENCY = 'EUR'
